module.exports = __webpack_public_path__ + "img/10881_L.76565a87.png";